function getNoArgHandler(logger, fn, args) {
    args = args || [];
    return () => {
        fn.apply(logger, args);
    };
}
function promiseWhenHandler(promise, operation, successLevel = 'info', errorLevel = 'error', progressLevel) {
    if (successLevel == null) {
        successLevel = 'info';
    }
    if (errorLevel == null) {
        errorLevel = 'error';
    }
    const successLevelFn = this[successLevel];
    if (typeof successLevelFn === 'function') {
        promise.then(getNoArgHandler(this, successLevelFn, [operation + '.success']));
    }
    const errorLevelFn = this[errorLevel];
    if (typeof errorLevelFn === 'function') {
        promise.catch(errorLevelFn.bind(this, operation + '.failed', 'error='));
    }
    const progressLevelFn = this[progressLevel];
    if (typeof progressLevelFn === 'function' && promise.progress) {
        promise.progress(progressLevelFn.bind(this, operation + '.progress', 'progress='));
    }
}
export default {
    pluginName: 'loggerWhen',
    dependencies: ['logger'],
    nodeMethods: {
        when: promiseWhenHandler,
    },
};
//# sourceMappingURL=logger_when.js.map